<template>
  <div class="warn-types none-height d-flex flex-column flex-grow-1">
    <div
      class="selector-container d-flex section-container"
      :class="{ dark: skinType }"
    >
      <SectionTitle title="访问控制"></SectionTitle>
      <el-form :inline="true" style="text-align: left" size="small">
        <el-form-item label="关键字" :class="{ 'light-label': skinType }">
          <el-input v-model="keywords" placeholder="关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="exportTable">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-on:click="addNew" icon="el-icon-plus">新建</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      size="small"
      :data="tableData"
      class="none-height flex-grow-1"
      style="width: 100%"
      height="0"
      ref="table"
      row-key="TabID"
      stripe
            :class="{ dark: skinType }"
      :row-class-name="
        (...nu) => {
          return skinType ? 'dark text-white' : '';
        }
      "
    >
      <el-table-column fixed type="index" width="60" label="#">
      </el-table-column>
      <el-table-column
        label="策略类型"
      >
         <template slot-scope="scope">
           <div>{{scope.row.F_Type?'允许访问':'拒绝访问'}}</div>
         </template>
      </el-table-column>
      <el-table-column prop="F_StartIP" label="起始IP" width="100"
        >
      </el-table-column>
      <el-table-column prop="F_EndIP" label="结束IP" width="160">
      </el-table-column>
      <el-table-column  label="是否有效" width="160">
          <template slot-scope="scope">
            <el-switch disabled :value="scope.row.F_EnabledMark"></el-switch>
          </template>
      </el-table-column>
      <el-table-column prop="F_CreatorUserId" label="创建人员" width="100">
      </el-table-column>
      <el-table-column prop="F_CreatorTime" label="创建时间" width="160">
      </el-table-column>
      <el-table-column prop="F_Description" label="备注"> </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)"
             :plain="!skinType">删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div
      class="d-flex section-container"
      style="padding: 1rem"
      :class="{ dark: skinType }"
    >
      <el-pagination
        v-if="pageInfo.total"
        style="margin-left: auto"
        background
        :class="{ 'text-white': skinType }"
        layout="total, prev, pager, next"
        :total="pageInfo.total"
        :current-page.sync="pageIndex"
      >
      </el-pagination>
    </div>
    <el-dialog :title="diaTitle"  :class=" {'dark' : skinType} " :visible.sync="dialogVisible">
      <AccessStategy
        :visible.sync="dialogVisible"
        :accessStategys="tableData"
        :selectAccessStategy="selectAccessStategy"
        @data-changed="requestStrategyList"
      ></AccessStategy>
    </el-dialog>
  </div>
</template>
<script>
import SectionTitle from '@/components/utils/section-title.vue';
import AccessStategy from '@/components/system-safety/components/dialog/access-strategy.vue';
import { getStrategyList, delStrategy } from '@/api/system-safety/index';
import { exportExcel } from '@/utils/utils';
import { showConfirm } from '@/utils/dialog';

export default {
  name: 'warn-types',
  components: {
    SectionTitle,
    AccessStategy,
  },
  data() {
    return {
      pageIndex: 1,
      pageInfo: {
        index: 1,
        size: 10,
        total: 1,
      },
      tableData: [],
      keywords: null,
      diaTitle: '',
      dialogVisible: false,
      selectAccessStategy: {},
    };
  },
  created() {
    this.requestStrategyList();
  },
  watch: {
    pageIndex() {
      this.requestStrategyList();
    },
    // 申请时间
    keywords() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
        return;
      }
      this.requestStrategyList();
    },
    // 申请类型
    applyClass() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
        return;
      }
      this.requestStrategyList();
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    onSubmit() {
      this.requestStrategyList();
    },
    exportTable() {
      exportExcel(this.$refs.table.$el);
    },
    pageChangeListener(no) {
      this.pageIndex = no;
    },
    requestStrategyList() {
      getStrategyList({
        page: this.pageIndex,
        rows: this.pageInfo.size,
        keyword: this.keywords,
      }).then((res) => {
        this.tableData = res.rows || res;
        this.pageInfo.total = res.total || 0;
      });
    },
    rowClickListener(row) {
      console.log(row);
    },
    // 添加
    addNew() {
      this.selectAccessStategy = {};
      this.dialogVisible = true;
      this.diaTitle = '新建访问策略';
    },
    // 编辑
    handleEdit(type) {
      this.selectAccessStategy = type;
      this.dialogVisible = true;
      this.diaTitle = `修改访问策略-${type.F_Description}`;
    },
    // 删除
    handleDelete(type) {
      console.log('type', type);
      const formData = new FormData();
      formData.append('keyValue', type.F_Id);
      showConfirm('访问策略', () => {
        console.log('删除', formData.get('keyValue'));
        return delStrategy(formData);
      }, this).then(this.requestStrategyList).catch((err) => {
        console.log('err', err);
      });
    },
  },
};
</script>

<style scoped>

</style>
